var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 214 34.3",
    style: {
      enableBackground: "new 0 0 214 34.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F3766;}\n\t.st1{fill:#F39200;}\n\t.st2{fill:#51C1E1;}\n\t.st3{fill:#77549E;}\n\t.st4{fill:#D8422E;}\n\t.st5{fill:#00A97E;}\n\t.st6{fill:#F9E005;}\n\t.st7{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0 16.8,16.8 33.5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,33.5 16.8,16.8 0,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "33.5,33.5 33.5,16.8 16.8,33.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "25.1,25.1 16.8,33.5 0,33.5 8.4,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "16.8,16.8 8.4,25.1 25.1,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "25.1,8.4 33.5,16.8 33.5,0  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    y: 10.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.4898 22.6893)",
    className: "st6",
    width: 11.8,
    height: 11.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M57.7,0H47v33.5h10.3c6.9,0,16.9-4.3,16.9-16.7S63.4,0,57.7,0z M57.1,27h-2.5V6.5h2.8c2.4,0,8.8,1.7,8.8,10.4 S59.3,27,57.1,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.6,11.7v3.1l-0.9-1c-0.9-1.1-3-2.8-6.3-2.8c-2.9,0-5.8,1.1-7.7,3.1c-1.2,1.3-3.3,4.1-3.3,8.8 c0,3.2,0.9,5.7,3.1,8.1c2.1,2.3,4.7,3.5,7.7,3.5c1.6,0,4.7-0.4,6.6-3.1l0.9-1.3v3.6h6.3V11.7H94.6z M88.4,28.4 c-3.1,0-5.7-2.6-5.7-5.8s2.5-5.8,5.7-5.8c3.1,0,5.7,2.6,5.7,5.8C94.1,25.8,91.6,28.4,88.4,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.9,11.7v3.1l-0.9-1c-0.9-1.1-3-2.8-6.4-2.8c-2.9,0-5.8,1.1-7.7,3.1c-1.2,1.3-3.3,4.1-3.3,8.8 c0,3.2,0.9,5.7,3.1,8.1c2.1,2.3,4.7,3.5,7.7,3.5c1.6,0,4.7-0.4,6.6-3.1l0.9-1.3v3.6h6.3V11.7H138.9z M132.8,28.4 c-3.1,0-5.7-2.6-5.7-5.8s2.5-5.8,5.7-5.8c3.1,0,5.7,2.6,5.7,5.8S135.9,28.4,132.8,28.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "107.6,0 107.6,11.7 105.1,11.7 105.1,17.3 107.6,17.3 107.6,33.5 114.6,33.5 114.6,17.3 119.2,17.3  119.2,11.7 114.6,11.7 114.6,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "202.4,0 202.4,33.5 209.4,33.5 209.4,17.3 214,17.3 214,11.7 209.4,11.7 209.4,0  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M170,22.2h-9.6l4.7-14.3L170,22.2z M174,33.5h8L169.6,0h-8.7l-12.6,33.5h7.9l2.3-5.9h13.4L174,33.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.5,33.5h7v-9.3c0-0.9,0-3.8,2-5.6c1-0.9,2.3-1.4,4-1.4c1.2,0,2.5,0,2.9,0v-5.6c-0.3,0-1.4-0.1-1.4-0.1 c-1.4,0-2.6,0-3.6,0.5c-1.3,0.6-2.3,1.7-3,3l-1,1.9v-5.3h-7L184.5,33.5L184.5,33.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataart);
export default __webpack_public_path__ + "static/media/Dataart.1bbec609e3945947eb8e6116bcbf0078.svg";
export { ForwardRef as ReactComponent };